<template>
	<div class="training-agreement">
		<div class="training-agreement__container container">
			<div
				class="agreement-head training-main-name main-title"
        v-html="pdf.name"
      ></div>
      <div style="margin-top: 1rem;">

        <div v-if="pdfUrl">
          <iframe
              :src="pdfUrl"
              width="100%"
              allow="fullscreen"
              style="height: 60vh;"
          ></iframe>
        </div>

        <div v-else>
          Cannot load PDF file.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	export default {
    created() {
      this.$store.dispatch("app/getPdf", {pdf_name: this.pdf.file}).then(resp => {
        if (resp) {
          this.pdfUrl = resp.pdf
        }
      });
    },

    mounted() {
      this.$emit("agreedWithAction")
      this.$emit("submit")
    },

    data() {
			return {
        pdfUrl: '',
				agreedWithAction: false,
			};
		},

		props: {
			pdf: Object,
			trainingAction: Object,
			transformDate: Function,
		},
	};
</script>
<style lang="scss"></style>
